<template>
  <div>
    <LoadingAnimation v-if="loading" />
    <!-- <Dashboard v-else /> -->
    <Dashboardtwo v-else />
  </div>
</template>

<script>
import LoadingAnimation from '@/components/loding.vue'; // 你的 loading 动画组件
import Dashboard from '@/components/DateChart.vue'; // 你的大屏内容组件 
import Dashboardtwo from '@/components/DateCharttwo.vue'; // 你的大屏内容组件 

export default {
  data() {
    return {
      loading: true, // 初始显示 loading 动画
      // 其他数据和状态...
    };
  },
  mounted() {
    // 模拟数据加载完成后切换显示
    setTimeout(() => {
      this.loading = false;
    }, 3000); // 假设数据加载耗时 2 秒
  },
  components: {
    LoadingAnimation,
    Dashboard,
    Dashboardtwo
  },
};
</script>
